import { Large, NotLarge } from "components/views/atoms/Responsive"
import { ResponsiveWrapper } from "components/views/molecules/Molecules"
import React, { FC, ReactNode } from "react"

type SidebarBaseProps = {
  children: ReactNode
}

const SideBarBase: FC<SidebarBaseProps> = ({ children }: SidebarBaseProps) => (
  <>
    <Large>
      <ResponsiveWrapper padding={0.5}>{children}</ResponsiveWrapper>
    </Large>
    <NotLarge>
      <ResponsiveWrapper padding={0.75}>{children}</ResponsiveWrapper>
    </NotLarge>
  </>
)

export { SideBarBase }
